import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { MapContainer, TileLayer, ZoomControl, useMap } from 'react-leaflet';
import L from 'leaflet';
import '@geoman-io/leaflet-geoman-free';
import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import '../lib/leafletIcons';
const centroid = (geom) => {
    // Average all coordinates — good enough for a marker/bbox center.
    const coords = [];
    const walk = (c) => {
        if (typeof c[0] === 'number')
            coords.push(c);
        else
            c.forEach(walk);
    };
    walk(geom.coordinates);
    const n = coords.length || 1;
    const lng = coords.reduce((s, c) => s + c[0], 0) / n;
    const lat = coords.reduce((s, c) => s + c[1], 0) / n;
    return { lat, lng };
};
const typeOf = (geom) => geom.type === 'Point' ? 'point' : geom.type === 'LineString' ? 'route' : 'zone';
function DrawLayer({ value, onChange }) {
    const map = useMap();
    useEffect(() => {
        // French labels/tooltips for the drawing toolbar (Geoman ships 'fr').
        map.pm.setLang('fr');
        // Toolbar: marker (point), line (route), polygon (zone), edit, drag, remove.
        map.pm.addControls({
            position: 'topright',
            drawMarker: true,
            drawPolyline: true,
            drawPolygon: true,
            drawCircle: false,
            drawCircleMarker: false,
            drawRectangle: false,
            drawText: false,
            cutPolygon: false,
            rotateMode: false,
        });
        map.pm.setGlobalOptions({ continueDrawing: false });
        // Keep a single shape on the map.
        const clearOthers = (keep) => {
            map.pm.getGeomanLayers().forEach((l) => { if (l !== keep)
                map.removeLayer(l); });
        };
        const emit = (layer) => {
            const geom = layer.toGeoJSON().geometry;
            onChange({ type: typeOf(geom), geometry: geom, center: centroid(geom) });
        };
        const onCreate = (e) => {
            clearOthers(e.layer);
            emit(e.layer);
            e.layer.on('pm:edit', () => emit(e.layer));
            e.layer.on('pm:dragend', () => emit(e.layer));
        };
        map.on('pm:create', onCreate);
        // Preload an existing shape for editing.
        if (value) {
            const layer = L.geoJSON(value);
            layer.eachLayer((l) => {
                l.addTo(map);
                l.on('pm:edit', () => emit(l));
                l.on('pm:dragend', () => emit(l));
            });
        }
        return () => {
            map.off('pm:create', onCreate);
            map.pm.removeControls();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);
    return null;
}
export function RoadworkMap({ center, value, onChange }) {
    return (_jsxs(MapContainer, { center: [center.lat, center.lng], zoom: 14, zoomControl: false, style: { height: 380, borderRadius: 12 }, children: [_jsx(ZoomControl, { position: "topleft", zoomInTitle: "Zoomer", zoomOutTitle: "D\u00E9zoomer" }), _jsx(TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: '\u00A9 OpenStreetMap' }), _jsx(DrawLayer, { value: value, onChange: onChange })] }));
}
